const StatusBar = ({
  language,
  theme,
  activeFile,
  languages,
  themes
}) => {
  return (
    <div className="bg-white border-t border-gray-200 px-6 py-2">
      <div className="flex items-center justify-between text-sm text-gray-600">
        <div className="flex items-center space-x-4">
          <span>Language: {languages.find(l => l.value === language)?.label}</span>
          <span>Theme: {themes.find(t => t.value === theme)?.label}</span>
          {activeFile && (
            <span>File: {
              typeof activeFile === 'string'
                ? activeFile
                : activeFile?.file?.name || activeFile?.name || 'Unknown File'
            }</span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          <span>Ready</span>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;